export default {"src":"/_next/static/media/origin.a0e0a528.svg","height":16,"width":16};